import { Box, Container, Typography, Paper } from "@mui/material";
import { EventsTable } from "../common/events-table/events-table";
import IconBreadcrumbs from "../custom-breadcrumb";

const EventsPage = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: { xs: 5, sm: 7, md: 10 },
                position: "relative",
                overflow: "hidden",
                background:
                    "radial-gradient(ellipse at 50% 0%, rgba(57,217,138,0.13), transparent 38%), radial-gradient(circle at 100% 45%, rgba(57,217,138,0.045), transparent 30%), linear-gradient(180deg, #06120A 0%, #08160D 52%, #040B06 100%)",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background:
                        "linear-gradient(90deg, transparent, rgba(57,217,138,0.8), transparent)",
                },
            }}
        >
            {/* BACKGROUND GLOW - TOP RIGHT */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-250px",
                    right: "-250px",
                    width: "650px",
                    height: "650px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.11) 0%, transparent 68%)",
                    filter: "blur(100px)",
                    pointerEvents: "none",
                }}
            />

            {/* BACKGROUND GLOW - BOTTOM LEFT */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: "-300px",
                    left: "-300px",
                    width: "700px",
                    height: "700px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.055) 0%, transparent 68%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* SUBTLE CENTER GLOW */}
            <Box
                sx={{
                    position: "absolute",
                    top: "35%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "500px",
                    height: "500px",
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(57,217,138,0.035), transparent 70%)",
                    filter: "blur(100px)",
                    pointerEvents: "none",
                }}
            />

            <Container
                maxWidth="lg"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* BREADCRUMB */}
                <Box
                    sx={{
                        mb: { xs: 4, md: 5 },
                        "& *": {
                            color: "#8BA995",
                        },
                    }}
                >
                    <IconBreadcrumbs />
                </Box>

                {/* HEADER */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: { xs: 5, md: 7 },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#39D98A",
                            fontWeight: 800,
                            letterSpacing: { xs: "2.5px", sm: "4px" },
                            fontSize: "11px",
                            mb: 1.5,
                            textTransform: "uppercase",
                            textShadow:
                                "0 0 20px rgba(57,217,138,0.2)",
                        }}
                    >
                        CRITICAL CONQUER • WORLD ACTIVITIES
                    </Typography>

                    <Typography
                        sx={{
                            color: "#FFFFFF",
                            fontWeight: 900,
                            fontSize: {
                                xs: "38px",
                                sm: "48px",
                                md: "62px",
                            },
                            lineHeight: 1,
                            mb: 2.5,
                            letterSpacing: "-1.5px",
                            textShadow:
                                "0 5px 30px rgba(0,0,0,0.5)",
                        }}
                    >
                        SERVER{" "}
                        <Box
                            component="span"
                            sx={{
                                color: "#39D98A",
                                textShadow:
                                    "0 0 30px rgba(57,217,138,0.22)",
                            }}
                        >
                            EVENTS
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(230,255,238,0.62)",
                            fontSize: {
                                xs: "14px",
                                md: "16px",
                            },
                            maxWidth: "720px",
                            mx: "auto",
                            lineHeight: 1.9,
                        }}
                    >
                        Your next adventure starts here. Check the event
                        schedule, prepare your character, and join the
                        battles and activities waiting for you in
                        Critical Conquer.
                    </Typography>

                    {/* DECORATIVE EMERALD LINE */}
                    <Box
                        sx={{
                            width: 100,
                            height: 3,
                            borderRadius: "10px",
                            background:
                                "linear-gradient(90deg, transparent, #39D98A, #9BFFC4, #39D98A, transparent)",
                            mx: "auto",
                            mt: 3,
                            boxShadow:
                                "0 0 18px rgba(57,217,138,0.2)",
                        }}
                    />
                </Box>

                {/* EVENTS CARD */}
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: {
                            xs: "20px",
                            md: "28px",
                        },
                        background:
                            "linear-gradient(145deg, rgba(12,29,19,0.98), rgba(5,14,8,0.98))",
                        border:
                            "1px solid rgba(57,217,138,0.18)",
                        boxShadow:
                            "0 25px 70px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.025)",
                        overflow: "hidden",
                        position: "relative",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #39D98A, #9BFFC4, #39D98A, transparent)",
                        },
                    }}
                >
                    {/* TOP HEADER */}
                    <Box
                        sx={{
                            px: {
                                xs: 3,
                                sm: 4,
                                md: 5,
                            },
                            py: {
                                xs: 3.5,
                                md: 4.5,
                            },
                            borderBottom:
                                "1px solid rgba(255,255,255,0.055)",
                            background:
                                "linear-gradient(135deg, rgba(57,217,138,0.07), rgba(7,20,12,0.98))",
                            position: "relative",

                            "&:after": {
                                content: '""',
                                position: "absolute",
                                right: 0,
                                top: 0,
                                width: "35%",
                                height: "100%",
                                background:
                                    "linear-gradient(90deg, transparent, rgba(57,217,138,0.035))",
                                pointerEvents: "none",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#9BFFC4",
                                fontWeight: 900,
                                fontSize: {
                                    xs: "25px",
                                    md: "34px",
                                },
                                lineHeight: 1.1,
                                mb: 1,
                                letterSpacing: "-0.5px",
                            }}
                        >
                            Event Schedule
                        </Typography>

                        <Typography
                            sx={{
                                color: "#8AA092",
                                fontSize: {
                                    xs: "13px",
                                    md: "14px",
                                },
                                lineHeight: 1.8,
                                maxWidth: "650px",
                            }}
                        >
                            Keep track of server activities and plan
                            your next move. Check the schedule before
                            heading into battle.
                        </Typography>

                        {/* SMALL EMERALD ACCENT */}
                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                borderRadius: "10px",
                                background:
                                    "linear-gradient(90deg, #39D98A, transparent)",
                                mt: 2,
                            }}
                        />
                    </Box>

                    {/* EVENTS TABLE */}
                    <Box
                        sx={{
                            p: {
                                xs: 1.5,
                                sm: 2.5,
                                md: 4,
                            },
                            overflowX: "auto",
                            color: "#FFFFFF",

                            "& table": {
                                borderCollapse: "separate",
                                borderSpacing: "0 6px",
                            },

                            "& th": {
                                color: "#9BFFC4",
                                fontWeight: 800,
                                fontSize: "11px",
                                letterSpacing: "1.5px",
                                textTransform: "uppercase",
                                borderColor:
                                    "rgba(57,217,138,0.12)",
                            },

                            "& td": {
                                color: "#B8C8BD",
                                borderColor:
                                    "rgba(255,255,255,0.045)",
                            },

                            "& tr": {
                                transition: "all 0.2s ease",
                            },

                            "& tbody tr": {
                                backgroundColor:
                                    "rgba(255,255,255,0.012)",
                            },

                            "& tbody tr:hover": {
                                background:
                                    "rgba(57,217,138,0.055)",
                            },

                            "& tbody tr:hover td": {
                                color: "#E7FFF0",
                                borderColor:
                                    "rgba(57,217,138,0.12)",
                            },
                        }}
                    >
                        <EventsTable />
                    </Box>
                </Paper>

                {/* CALL TO ACTION */}
                <Box
                    sx={{
                        mt: {
                            xs: 6,
                            md: 9,
                        },
                        textAlign: "center",
                        position: "relative",
                        background:
                            "linear-gradient(145deg, rgba(12,29,19,0.98), rgba(5,14,8,0.98))",
                        borderRadius: {
                            xs: "22px",
                            md: "28px",
                        },
                        py: {
                            xs: 5,
                            md: 7,
                        },
                        px: 3,
                        border:
                            "1px solid rgba(57,217,138,0.16)",
                        boxShadow:
                            "0 25px 60px rgba(0,0,0,0.4)",
                        overflow: "hidden",

                        "&:before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "40%",
                            height: "2px",
                            background:
                                "linear-gradient(90deg, transparent, #39D98A, transparent)",
                        },

                        "&:after": {
                            content: '""',
                            position: "absolute",
                            width: 350,
                            height: 350,
                            borderRadius: "50%",
                            left: "50%",
                            bottom: -280,
                            transform: "translateX(-50%)",
                            background:
                                "rgba(57,217,138,0.055)",
                            filter: "blur(80px)",
                            pointerEvents: "none",
                        },
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            zIndex: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#39D98A",
                                fontWeight: 800,
                                letterSpacing: "3px",
                                fontSize: "11px",
                                mb: 1.5,
                                textTransform: "uppercase",
                            }}
                        >
                            YOUR NEXT CHALLENGE AWAITS
                        </Typography>

                        <Typography
                            sx={{
                                color: "#FFFFFF",
                                fontWeight: 900,
                                fontSize: {
                                    xs: "32px",
                                    sm: "42px",
                                    md: "54px",
                                },
                                lineHeight: 1.1,
                                mb: 2.5,
                                letterSpacing: "-1px",
                            }}
                        >
                            Enter the{" "}
                            <Box
                                component="span"
                                sx={{
                                    color: "#39D98A",
                                    textShadow:
                                        "0 0 25px rgba(57,217,138,0.18)",
                                }}
                            >
                                Battlefield
                            </Box>
                        </Typography>

                        <Typography
                            sx={{
                                color: "#8AA092",
                                fontSize: {
                                    xs: "14px",
                                    md: "16px",
                                },
                                maxWidth: "680px",
                                mx: "auto",
                                lineHeight: 1.9,
                            }}
                        >
                            Sharpen your skills, stand with your guild,
                            and make every battle count. Join the
                            Critical Conquer community and build your
                            own legacy in the classic era.
                        </Typography>

                        {/* DECORATIVE DIVIDER */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 2,
                                mt: 3.5,
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: "1px",
                                    background:
                                        "linear-gradient(90deg, transparent, rgba(57,217,138,0.4))",
                                }}
                            />

                            <Box
                                sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    background: "#39D98A",
                                    boxShadow:
                                        "0 0 12px rgba(57,217,138,0.45)",
                                }}
                            />

                            <Box
                                sx={{
                                    width: 60,
                                    height: "1px",
                                    background:
                                        "linear-gradient(90deg, rgba(57,217,138,0.4), transparent)",
                                }}
                            />
                        </Box>
                    </Box>
                </Box>

                {/* BOTTOM BRAND */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, transparent, rgba(57,217,138,0.3))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#557060",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Critical Conquer • Classic Edition
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background:
                                "linear-gradient(90deg, rgba(57,217,138,0.3), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default EventsPage;